import React, { Component, PropTypes } from 'react'
import Loader from 'react-loader'
import CSSModules from 'react-css-modules'
const Styles = require('./BondDemoRedirect.css')

@CSSModules(Styles, {allowMultiple:true})
export default class BondSurveyRedirect extends Component {
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {}
  }
  componentWillMount() {}
  componentDidMount() {
    window.location.replace('https://forms.gle/ZMJExbApCzTwtxkL8')
  }
  componentWillReceiveProps(nextProps) {}
  componentWillUnmount() {}
  render() {
    return (
      <div styleName='main'>
        <Loader options={{scale: 0.70, top:'2.0rem'}} loaded={ false }/>
      </div>
    )
  }
}
